import React from 'react'
import Spinner from '@active/react-ui/Spinner'
import { createRoot } from 'react-dom/client'
import { getRootElement } from '@active/react-ui/config'

import LoadingCounter from './LoadingCounter'
import './spinner.scss'

const loadingCounter = new LoadingCounter()
// There only should be one global loading instance
let loadingInstance; let
  loadingRoot

function _close(div) {
  loadingRoot?.unmount()

  div.parentNode && div.parentNode.removeChild(div)
}
function show() {
  if (loadingCounter.isEmpty()) {
    const div = document.createElement('div')
    getRootElement().appendChild(div)

    loadingRoot = createRoot(div)
    loadingRoot.render(<div id="passport-loading" className="modal-root" data-testid="modal-root">
      <div className="mask fade-in layer-modal" />
      <div tabIndex="-1" className="modal layer-modal modal-sm" aria-modal="true" aria-describedby="dialog_body">
        <Spinner type="super" />
      </div>
    </div>)

    loadingInstance = {
      close: function close() {
        loadingCounter.clear()
        _close(div)
      },
      counter: loadingCounter,
    }

    loadingCounter.add()
  }

  return loadingInstance
}

function hide() {
  if (!loadingCounter.isEmpty()) {
    loadingCounter.dec()

    loadingInstance.close()
  }
}

function reset() {
  loadingCounter.clear()
}

export { show, hide, reset }
